import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ServerReqDto } from '../_dtos/serverReqDto';
import { ServerResDto } from '../_dtos/serverResDto';

@Injectable({
  providedIn: 'root',
})
export class ServersService {
  private serversApi = environment.backendBaseUrl + '/Servers';

  constructor(private http: HttpClient) {}

  saveServerData(serverData: ServerReqDto): Observable<ServerResDto> {
    return this.http.post<ServerResDto>(this.serversApi, serverData);
  }

  deleteServer(id: string) {
    const serverDeleteUri = `${this.serversApi}/${id}`;
    return this.http.delete<void>(serverDeleteUri);
  }
}
